import { OnlineStatusEnums } from '@/enums/OnlineStatusEnums';

export interface IOnlineStatusModel {
    status: OnlineStatusEnums;
    message?: string;
}

export class OnlineStatusModel implements IOnlineStatusModel {
    public status: OnlineStatusEnums;
    public message?: string;

    constructor(obj: IOnlineStatusModel);
    constructor(obj?: any) {

        this.status = obj && obj.status || 0;

        if (obj && obj.message) {
            this.message = obj.message;
        }

    }
}
